import { ModalCustom } from "components/ModalCustom";
import { ContainerMensagem, Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export function ModalCertezaRemoverProcessos({
  show,
  handleClose,
  onConfirm,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Remover processos"
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={onConfirm}
      confirmButtonText="Remover"
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>
        <ContainerMensagem>
          Deseja remover o(s) processo(s) selecionado(s) deste lote de
          pagamento?
        </ContainerMensagem>
      </ModalBody>
    </ModalCustom>
  );
}
